import React from 'react';
import Dropzone from 'react-dropzone';

import { CircularProgressbar } from 'react-circular-progressbar';
import Button from 'components/Button';

import {
  FiUpload,
  FiX,
  FiCheck,
  FiCheckCircle,
  FiXCircle,
} from 'react-icons/fi';

import { Container, DropContainer, FileInfo } from './styles';
interface UploadProps {
  disabled: boolean;
  name?: string;
  accept: {
    [key: string]: string[];
  };
  selectedFiles: any[];
  onUpload: (files: any[]) => void;
  style?: { width: string };
}
export default function Upload({
  onUpload,
  selectedFiles,
  disabled,
  accept,
  name = 'Clique ou arraste a planilha',
  style,
  ...rest
}: UploadProps) {
  function renderDragmessage(
    isDragActive: boolean,
    isDragReject: boolean,
    disabled: boolean,
  ) {
    if (!isDragActive) {
      return (
        <Button {...rest} color="primary" disabled={disabled}>
          {name} <FiUpload />
        </Button>
      );
    }

    if (isDragReject) {
      return (
        <Button {...rest} color="danger" disabled={disabled}>
          Arquivo não suportado
          <FiX />
        </Button>
      );
    }

    return (
      <Button {...rest} color="success" disabled={disabled}>
        Solte o arquivo aqui
        <FiCheck />
      </Button>
    );
  }

  return (
    <Container>
      {!selectedFiles.length && (
        <Dropzone
          accept={accept}
          multiple={false}
          onDropAccepted={onUpload}
          disabled={disabled}
        >
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
            <DropContainer
              className="dropzone"
              {...getRootProps()}
              // isDragActive={isDragActive}
              // isDragReject={isDragReject}
            >
              <input {...getInputProps()} />
              {renderDragmessage(isDragActive, isDragReject, disabled)}
            </DropContainer>
          )}
        </Dropzone>
      )}
      {!!selectedFiles.length && (
        <FileInfo>
          {selectedFiles.map(file => (
            <li key={file.id}>
              <div>
                <strong>{file.name}</strong>
                <span>{file.readableSize}</span>
              </div>
              <div>
                {!file.uploaded && !file.error && (
                  <CircularProgressbar
                    styles={{
                      root: { width: 24 },
                      path: { stroke: '#7159c1' },
                    }}
                    strokeWidth={10}
                    value={file.progress}
                  />
                )}

                {file.uploaded && <FiCheckCircle />}
                {file.error && <FiXCircle />}
              </div>
            </li>
          ))}
        </FileInfo>
      )}
    </Container>
  );
}

// Upload.defaultProps = {
//   selectedFiles: [],
//   accept: '',
//   name: 'Clique ou arraste a planilha',
//   disabled: false,
// };
